import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import './AdminDashboard.css';

const AdminDashboard = () => {
    const [stats, setStats] = useState({
        totalContacts: 0,
        totalSubscribers: 0,
        totalViews: 0,
        projects: 0
    });
    const navigate = useNavigate();

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const token = localStorage.getItem('adminToken');
                const response = await axios.get('/api/stats', {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setStats(response.data);
            } catch (err) {
                if (err.response?.status === 401) {
                    localStorage.removeItem('adminToken');
                    navigate('/admin/login');
                }
            }
        };

        fetchStats();
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem('adminToken');
        navigate('/admin/login');
    };

    const statCards = [
        { label: 'Total Contacts', value: stats.totalContacts, color: '#6366f1', icon: '✉️' },
        { label: 'Subscribers', value: stats.totalSubscribers, color: '#10b981', icon: '📰' },
        { label: 'Project Views', value: stats.totalViews, color: '#f59e0b', icon: '👁️' },
        { label: 'Total Projects', value: stats.projects, color: '#ec4899', icon: '🚀' },
    ];

    return (
        <div className="admin-dashboard">
            <nav className="admin-nav">
                <div className="nav-brand">
                    <h2>AI CoE Admin</h2>
                </div>
                <div className="nav-actions">
                    <Link to="/" className="nav-link">Main Site</Link>
                    <button onClick={handleLogout} className="logout-btn">Logout</button>
                </div>
            </nav>

            <main className="dashboard-content">
                <header className="dashboard-header">
                    <motion.h1
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                    >
                        Dashboard Overview
                    </motion.h1>
                    <p>Real-time performance and audience metrics</p>
                </header>

                <div className="stats-grid">
                    {statCards.map((card, index) => (
                        <motion.div
                            key={card.label}
                            className="stat-card"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.1 }}
                        >
                            <div className="stat-icon">{card.icon}</div>
                            <div className="stat-info">
                                <h3>{card.value}</h3>
                                <p>{card.label}</p>
                            </div>
                            <div className="stat-progress" style={{ backgroundColor: card.color }}></div>
                        </motion.div>
                    ))}
                </div>

                <section className="management-sections">
                    <h2>Content Management</h2>
                    <div className="management-grid">
                        <Link to="/admin/projects" className="manage-card">
                            <div className="manage-icon">📂</div>
                            <div className="manage-info">
                                <h3>Manage Projects</h3>
                                <p>Add, edit or remove portfolio items</p>
                            </div>
                        </Link>
                        <Link to="/admin/research" className="manage-card">
                            <div className="manage-icon">🔬</div>
                            <div className="manage-info">
                                <h3>Manage Research</h3>
                                <p>Update research areas and publications</p>
                            </div>
                        </Link>
                        <Link to="/admin/contacts" className="manage-card">
                            <div className="manage-icon">💬</div>
                            <div className="manage-info">
                                <h3>Inquiries</h3>
                                <p>View and manage contact form submissions</p>
                            </div>
                        </Link>
                        <Link to="/admin/subscribers" className="manage-card">
                            <div className="manage-icon">📧</div>
                            <div className="manage-info">
                                <h3>Subscribers</h3>
                                <p>View newsletter subscription list</p>
                            </div>
                        </Link>
                    </div>
                </section>
            </main>
        </div>
    );
};

export default AdminDashboard;
